import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axiosClient from 'api/axiosClient'
import { Container, Row } from 'reactstrap';
import Loader from "react-loader-spinner";
import ReactHtmlParser from 'react-html-parser'
import SlideResearch from './SlideResearch/SlideResearch';
//optimize image
// import Img from 'react-optimized-image';

import ISIImg from 'assets/img/researchImages/ISI-background.jpeg';


import './style.css';
import { useIntl } from 'react-intl';



export default function Research(props) {
    const unit = props.unit;
            const intl = useIntl();
    
    const [infoNewsPublication, setinfoNewsPublication] = useState([])
    const [infoNewsPatent, setinfoNewsPatent] = useState([])
    const [loaded, setLoaded] = useState()

    useEffect(() => {
        // set loading to wait get data
        setLoaded(false)
        const requestUrlPublication = `/publications?page=1&size=2&type=publication&isFeatured=1&unit=${unit}`
        const requestUrlPatent = `/publications?page=1&size=2&type=patent&isFeatured=1&unit=${unit}`
        axiosClient.get(requestUrlPublication).then(response => {
            const temp = response.data
            setinfoNewsPublication(temp)
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })
        axiosClient.get(requestUrlPatent).then(response => {
            const temp = response.data
            setinfoNewsPatent(temp)
            setLoaded(true)
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })

    }, [])
    return (
        <Container className="wp-research">
            <h2 className="research-title">Research</h2>
            {
                !loaded ? <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" /> :
                    <div>
                        <Row className="Research" style={{ marginRight: '0px', marginLeft: '0px' }}>
                            
                            <div className="reseach-body">
                                <div className="research-item" style={{marginRight:'30px'}}>
                                    <img src={ISIImg} alt="img"></img>
                                    <div className="ISI-item research-content">
                                        <h4>ISI, Scopus Collection</h4>
                                        <div className="ISI-body">
                                            {infoNewsPublication.map((item, index) => {
                                                return (
                                                    <ul>
                                                        <li>
                                                            <p className="infoCollection">
                                                                {ReactHtmlParser(item.authors)},"{ReactHtmlParser(item.title)}", {item.resource.includes("<p>") ? ReactHtmlParser(item.resource) : <p>{item.resource}</p>}, <p>{item.publish_month == 0 ? "" : `${item.publish_month}.`}{item.publish_year}</p>
                                                            </p>
                                                        </li>

                                                    </ul>
                                                )
                                            })
                                            }
                                        </div>
                                        <Link to={`/research/list`} className="viewAllCollection"> {intl.formatMessage({ id: 'View All' })} </Link>
                                    </div>
                                </div>
                                <div className="research-item">
                                    <div className="research-content" style={{paddingTop: '0px'}}>
                                        <SlideResearch/>
                                    </div>
                                </div>
                            </div>
                        </Row>
                       
                    </div>
            }

        </Container>
    )
}
